import {
  Autocomplete,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Orders,
  setOrderSerialsDialog,
} from "../../app/slices/store/ordersSlice";
import { showNotification } from "../../app/slices/notificationSlice";

const UpdateSerialsDialog = () => {
  const dispatch = useDispatch();
  const { order_serials } = useSelector((state) => state.orders);

  const [items, setItems] = useState(
    order_serials.form.items.map((item) => ({
      item_id: item.item_id,
      name: item.name,
      count: item.count,
      sn: [...(item.sn || [])],
      original_sn: [...(item.sn || [])],
    }))
  );

  const handleDialog = () => {
    dispatch(setOrderSerialsDialog());
  };

  const setItemSn = (index, sn) => {
    const newItems = [...items];
    newItems[index] = { ...newItems[index], sn };
    setItems(newItems);
  };

  const isChanged = (item) =>
    item.sn.length !== item.original_sn.length ||
    item.sn.some((s, i) => s !== item.original_sn[i]);

  const onSubmit = () => {
    const changed = items.filter(isChanged);
    if (changed.length === 0) {
      dispatch(
        showNotification({
          type: "warning",
          message: "No serial changes to save",
        })
      );
      return;
    }
    const payload = changed.map((item) => ({
      item_id: item.item_id,
      sn: item.sn,
    }));
    dispatch(Orders.updateSerials(order_serials.form.order_id, payload));
  };

  return (
    <Dialog
      open={order_serials.dialog}
      keepMounted
      fullWidth={true}
      dir="ltr"
      maxWidth={"md"}
      onClose={handleDialog}
    >
      <DialogTitle
        children={
          <Typography color={"primary"} variant="h6" fontWeight={"bold"}>
            Fix Serials
          </Typography>
        }
      />
      <DialogContent>
        <Grid container spacing={1} mt={1}>
          {items.map((item, index) => (
            <React.Fragment key={item.item_id}>
              <Grid item xs={8}>
                <TextField
                  disabled
                  value={item.name}
                  label="Item name"
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  disabled
                  label="Count"
                  value={item.count}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <Autocomplete
                  multiple
                  id={`sn-tags-${item.item_id}`}
                  options={item.sn}
                  value={item.sn}
                  freeSolo
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && e.target.value) {
                      if (item.sn.length >= item.count) {
                        e.preventDefault();
                        dispatch(
                          showNotification({
                            type: "warning",
                            message: `عدد السيريالات اكبر من العدد (${item.count})`,
                          })
                        );
                        return;
                      }
                      setItemSn(index, [...item.sn, e.target.value]);
                    }
                  }}
                  onChange={(e, newValue) => {
                    if (newValue.length > item.count) {
                      dispatch(
                        showNotification({
                          type: "warning",
                          message: `عدد السيريالات اكبر من العدد (${item.count})`,
                        })
                      );
                      return;
                    }
                    setItemSn(index, newValue);
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, i) => (
                      <Chip
                        variant="outlined"
                        label={option}
                        {...getTagProps({ index: i })}
                      />
                    ))
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Serial Numbers"
                      size="small"
                      placeholder="Serial Numbers"
                      helperText={`Press Enter to add (max ${item.count})`}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider sx={{ my: 1 }} />
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
        <DialogActions dir="ltr">
          <LoadingButton
            color="primary"
            variant="contained"
            loading={order_serials.loading}
            onClick={onSubmit}
          >
            Save Serials
          </LoadingButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateSerialsDialog;
